import CardItemDTO from '@src/adapters/dto/card/CardItemDTO';
import useApi, { ApiOptions } from '../base/useApi';
import { CardModificationDTO } from '@src/adapters/dto/card/CardModificationDTO';
interface Params {
  cardId: string;
  id: string;
  note?: string;
  qtyOpen: number;
  qtyOnHand: number;
  isLoan: boolean;
}

interface Result {
  cardItem: CardItemDTO;
  modification: CardModificationDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/card/save_item_details/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveCardItemDetailsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveCardItemDetailsLazy;
